export default {
      id: "ic-misc-phone-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-misc-phone-usage",
      toString: function () {
        return this.url;
      }
    }